import { render, staticRenderFns } from "./questionPaper2.vue?vue&type=template&id=6ae51ce3&scoped=true"
import script from "./questionPaper2.vue?vue&type=script&lang=js"
export * from "./questionPaper2.vue?vue&type=script&lang=js"
import style0 from "./questionPaper2.vue?vue&type=style&index=0&id=6ae51ce3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae51ce3",
  null
  
)

export default component.exports